import mixpanel from "mixpanel-browser";

const isProduction =
  process.env.NEXT_PUBLIC_NODE_ENV === "production" ||
  process.env.NEXT_PUBLIC_NODE_ENV === "staging";

let mixpanelOn = false;

export const Init = (): void => {
  if (isProduction) {
    if (process.env.NEXT_PUBLIC_MIXPANEL_TOKEN) {
      mixpanel.init(process.env.NEXT_PUBLIC_MIXPANEL_TOKEN, {
        debug: true,
        record_sessions_percent: 100,
      });
      mixpanelOn = true;
    } else {
      console.error(
        "Mixpanel token não encontrado. Mixpanel não será inicializado.",
      );
    }
  }
};

interface UserPayload {
  username?: string;
  fullName?: string;
  email?: string;
  role?: string;
  tenant?: { name?: string };
}

export const Identify = (id: string, userPayload?: UserPayload): void => {
  if (!id) {
    Track("ID não enviado, não possível identificar o usuário no mixpanel");
    return;
  }

  if (isProduction) {
    mixpanel.identify(id);

    if (userPayload) {
      mixpanel.people.set({
        $username: userPayload.username,
        $name: userPayload.fullName,
        $fullName: userPayload.fullName,
        $email: userPayload.email,
        $role: userPayload.role,
        $tenant: userPayload.tenant?.name,
      });
    }
  }
};

export const Track = (event_name: string, props?: Record<string, unknown>): void => {
  if (isProduction && mixpanelOn) {
    mixpanel.track(event_name, props);
  }
};

export const TimeEvent = (event_name: string): void => {
  if (isProduction && mixpanelOn) {
    mixpanel.time_event(event_name);
  }
};

export function getDurationFormatted(startTime: number): {
  duration_seconds: number;
  duration_formatted: string;
} {
  const duration = Math.floor((Date.now() - startTime) / 1000);
  const hours = Math.floor(duration / 3600);
  const minutes = Math.floor((duration % 3600) / 60);
  const seconds = duration % 60;
  const duration_formatted = [
    hours.toString().padStart(2, "0"),
    minutes.toString().padStart(2, "0"),
    seconds.toString().padStart(2, "0"),
  ].join(":");
  return { duration_seconds: duration, duration_formatted };
}
